import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { UserService } from "src/app/services/user.service";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { MatDialog } from "@angular/material/dialog";
import { UserComponent } from "../user/user.component";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { ConfirmationDialogComponent } from "src/app/components/confirmation-dialog/confirmation-dialog.component";
import { HeaderComponent } from "src/app/components/header/header.component";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { UserModel } from "src/app/Models";
import { auto } from "@popperjs/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

declare var $: any;

@Component({
  selector: "app-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.css"],
})
export class UserListComponent implements OnInit {
  public title: string;
  public userDivFlag: boolean;
  public addButton: boolean;
  public searchText: any;

  public userRoles = UserRoles;
  users = [];
  public loading = false;
  @ViewChild("actions") actions: ElementRef;
  @ViewChild(HeaderComponent) header: HeaderComponent;

  public roles = [
    {
      option: "Admin",
      value: "Admin",
    },
    {
      option: "Viewer",
      value: "Viewer",
    },
  ];
  public signedInUserDetails = {
    email: this.auth.getEmailId(),
    role: this.auth.getRole(),
    organizationId: this.auth.getOrganizationId(),
  };

  formData = new UntypedFormGroup({
    username: new UntypedFormControl(""),
    email: new UntypedFormControl(""),
    role: new UntypedFormControl(""),
  });

  public user: UserModel;
  deleteList: any[] = [];
  constructor(
    private userService: UserService,
    public dialog: MatDialog,
    private router: Router,
    private cd: ChangeDetectorRef,
    private auth: AuthServiceService,
    private toastr: ToastrService
  ) {
    this.userDivFlag = false;
  }

  ngOnInit() {
    this.searchText = '';
    this.userDivFlag = false;
    this.addButton = true;
    this.fetchAllUsers();
  }
  ngAfterViewInit() {
    this.header.backgroundColor = true;
  }

  fetchAllUsers() {
    this.loading = true;
    this.userService.fetchUsersList().subscribe(
      (res) => {
        this.loading = false;
        this.users = res;
        this.cd.detectChanges();
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  searchUser() {
    if (this.searchText !== "") {
      this.loading = true;
      this.userService.searchGrid(this.searchText).subscribe(
        (res) => {
          this.users = res;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: "Please try again", class: "text-danger" },
          });
        }
      );
    } else {
      this.fetchAllUsers();
    }
  }

  updateUser(user: UserModel) {
    this.title = "Edit User";
    const dialogRef = this.dialog.open(UserComponent, {
      width: '1000px',
      height: 'auto',
      disableClose: true,
      data: { user, title: "Update User" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.data !== "no") {
          this.loading = true;
          setTimeout(() => {
            this.fetchAllUsers();
          }, 500);
        }
      } else {
        setTimeout(() => {
          this.fetchAllUsers();
        }, 1000);
      }
    });
  }

  deleteUser(userId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data === "DELETE") {
        this.loading = true;
        this.userService.deleteUser(userId).subscribe((res) => {
          this.toastr.error("User Deleted Successfully");
          this.loading = true;
          setTimeout(() => {
            this.fetchAllUsers();
          }, 1000);
        });
      }
    });
  }

  addUser() {
    this.title = "Add User";
    const dialogRef = this.dialog.open(UserComponent, {
      width: '1000px',
      height: 'auto',
      data: { title: "New User" },
      panelClass: 'bg-color',
    })
      ;

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.data !== "no") {
          this.loading = true;
          setTimeout(() => {
            this.fetchAllUsers();
          }, 500);
        }
      } else {
        setTimeout(() => {
          this.fetchAllUsers();
        }, 1000);
      }
    });
  }

  addToDeleteList(user, event) {
    if (event.checked) {
      this.deleteList.push(user.id);
    } else {
      const index = this.deleteList.findIndex((ele) => ele === user.id);
      if (index >= 0) {
        this.deleteList.splice(index, 1);
      }
    }
    if (this.deleteList.length > 0) {
      this.actions.nativeElement.style.right = "0px";
    } else {
      this.actions.nativeElement.style.right = "-300px";
    }
  }

  dismissSidebar() {
    $("#sidebar").removeClass("active");
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }

  deleteMultipleUsers() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;

        this.userService.deleteMultipleUsers(this.deleteList).subscribe(
          (res) => {
            this.toastr.error("Selected Users Deleted Successfully");
            this.loading = false;
            this.deleteList = [];
            this.actions.nativeElement.style.right = "-300px";
            setTimeout(() => {
              this.fetchAllUsers();
            }, 500);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }
  getRole(role) {
    return role.split(".")[1];
  }
  checkRole(role) {
    return this.auth.getRole().indexOf(role) >= 0;
  }
  onKeyDown(event: KeyboardEvent)
   {    if (event.key === 'Backspace' && this.searchText.length === 1)
    {      this.clearSearchText();    }  
  }
  clearSearchText() {
    this.searchText = "";
    this.fetchAllUsers();
  }
  switchDeckView() {
    this.router.navigate(['Home/KMSPortal'])
  }
  goToHome() {
    this.router.navigate(['Home'])
  }

}
